'use es6';

import { combineReducers } from 'redux';
import { App } from './App';
import Achievement from './Achievement';
import Auth from './Auth';
import AvailableLanguages from './AvailableLanguages';
import Favorites from './Favorites';
import FavoritesTooltip from './FavoritesTooltip';
import ContentById from './ContentById';
import DismissedAlerts from './DismissedAlerts';
import Filters from './Filters';
import Lessons from './Lessons';
import ProgressTransfer from './ProgressTransfer';
import Tracks from './Tracks';
import GettingStarted from './GettingStarted';
import Recommendations from './Recommendations';
import AcademyToSoftware from './AcademyToSoftware';
import Accounts from './Accounts';
import Wizard from './Wizard';
import Products from './Products';
export default combineReducers({
  app: App,
  accounts: Accounts,
  achievement: Achievement,
  auth: Auth,
  availableLanguages: AvailableLanguages,
  favorites: Favorites,
  favoritesTooltip: FavoritesTooltip,
  contentById: ContentById,
  dismissedAlerts: DismissedAlerts,
  filters: Filters,
  lessons: Lessons,
  progressTransfer: ProgressTransfer,
  tracks: Tracks,
  gettingStarted: GettingStarted,
  recommendations: Recommendations,
  academyToSoftware: AcademyToSoftware,
  wizard: Wizard,
  products: Products
});